import api from './api';
import { APIProxy } from './api-proxy';
const getOrderByOrderNoTDMS = (orderNo: string) =>
  api.get(
    `/saphybris-proxy/v1/saphybris/trackingServiceV2?orderNo=${orderNo}`,
    false,
    false,
    false,
    false
  );

const getOrderByOrderNoTDMSV2 = (orderNo: string, req?, res?) => {
  if (req && res) {
    const apiProxy = new APIProxy(req, res);

    return apiProxy.makeRequest({
      method: req.method!,
      url: `/saphybris-proxy/v1/saphybris/tracking-unit-service?orderNo=${orderNo}&isPushNotif=false`,
    });
  } else {
    return api.get(
      `/saphybris-proxy/v1/saphybris/tracking-unit-service?orderNo=${orderNo}`,
      false,
      false,
      false,
      false
    );
  }
};

export default {
  getOrderByOrderNoTDMS,
  getOrderByOrderNoTDMSV2,
};
